import {
  COST_FETCH_UNITS_BEGIN,
  COST_FETCH_UNITS_SUCCESS,
  COST_FETCH_UNITS_FAILURE,
  COST_FETCH_UNITS_DISMISS_ERROR,
} from './constants';
import {SERVER_PATH, AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchUnits(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: COST_FETCH_UNITS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      axios.get(SERVER_PATH +'/units/getAll/', AXIOS_CONFIG())
      .then(
        (res) => {
          dispatch({
            type: COST_FETCH_UNITS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: COST_FETCH_UNITS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissFetchUnitsError() {
  return {
    type: COST_FETCH_UNITS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COST_FETCH_UNITS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchUnitsPending: true,
        fetchUnitsError: null,
      };

    case COST_FETCH_UNITS_SUCCESS:
      // The request is success
      return {
        ...state,
        fetchUnitsPending: false,
        fetchUnitsError: null,
      };

    case COST_FETCH_UNITS_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchUnitsPending: false,
        fetchUnitsError: action.data.error,
      };

    case COST_FETCH_UNITS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchUnitsError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/cost/redux/fetchUnits.js